// Number formatting utilities for InfluenceHub
// Provides compact number formatting and percentage formatting

export const formatCompact = (n) => {
  if (n === null || n === undefined || n === "") return "";
  const num = Number(n);
  if (Number.isNaN(num)) return String(n);
  // 1,234 -> 1.23K, 1,200,000 -> 1.2M
  return Intl.NumberFormat("en", { notation: "compact", maximumFractionDigits: 1 }).format(num);
};

export const formatPct = (v) => {
  if (v === null || v === undefined || v === "") return "";
  return typeof v === "number" ? `${v}%` : (/\d%$/.test(String(v)) ? String(v) : `${v}%`);
};
